import { SvgIcon, SvgIconProps } from "@mui/material";
import type { JSX } from "react";

export const RealEstatePriceIndexIcon = (props: SvgIconProps): JSX.Element => (
  <SvgIcon sx={{ width: "40px", height: "32px" }} {...props}>
    <svg width="40" height="32" viewBox="0 0 40 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M39 31L1 31"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeDasharray="3 4"
      />
      <path
        d="M1 31L1 1"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
        strokeLinejoin="round"
        strokeDasharray="3 4"
      />
      <path
        d="M6 23C9.6 19.5778 11.5 18.7222 12 18.7222H14.625L19.125 19.8889L23.25 18.7222L25.5 16.7778L29.625 14.8333L33.75 13.2778L36 9"
        stroke="#C8B085"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </SvgIcon>
);
